import { gapi } from "gapi-script";
import { GoogleKeys } from '../../google.keys';

const initClient = () => {
  gapi.client.init({
    clientId: GoogleKeys.webClientId,
    scope: '', 
  });
};

export const initGoogleAuth = () => {
  gapi.load('client:auth2', initClient);
};
